/**
 * An <input> control
 *
 * Available Options:
 *     - name (required)
 *     - value (optional)
 *     - placeholder (optional)
 *     - disabled (optional)
 */

import $ from 'jquery'
import _ from 'lodash'

import SearchFormControl from 'component/search_form/control/control'
import template from 'component/search_form/control/text/text.tmpl'
import errorTemplate from 'component/search_form/control/error.tmpl'

export default SearchFormControl.extend({
    template,
    errorTemplate,

    defaultOptions: {
        disabled: false,
        label: false,
        minlength: false,
        maxlength: false,
        noSpacing: false,
        placeholder: '',
        required: false,
    },

    events: {
        'blur input': '_onInputBlur',
        'keyup input': '_onInputKeyup',
    },

    initialize(options) {
        SearchFormControl.prototype.initialize.call(this, options)
        this.options = this.pickOptions(options, this.defaultOptions)

        this._onInputKeyup = _.debounce(this._onInputKeyup, 500)
    },

    render() {
        this.$el.html(
            this.template({
                value: this._value,
                name: this._name,
                disabled: this.options.disabled,
                label: this.options.label,
                minlength: this.options.minlength,
                maxlength: this.options.maxlength,
                noSpacing: this.options.noSpacing,
                placeholder: this.options.placeholder,
                required: this.options.required,
            })
        )

        this.renderError()
        return this
    },

    renderError(error) {
        this.$('.js-control-error').html(this.errorTemplate({ error }))
    },

    _onInputBlur(e) {
        const value = $(e.currentTarget).val().trim()
        this.value(value)
    },

    _onInputKeyup(e) {
        const value = $(e.currentTarget).val().trim()

        if (value) {
            this.value(value)
        }
    },

    focus() {
        this.$('input').trigger('focus')

        return this
    },

    blur() {
        this.$('input').trigger('blur')

        return this
    },

    getField() {
        return this.$('.js-text')
    },
})
